/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualRentDto } from '../../models/backend-actual-rent-dto';

export interface MonitoringActualsRentsRetrieve$Params {
  id: number;
}

export function monitoringActualsRentsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsRentsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualRentDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsRentsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualRentDto>;
    }),
  );
}

monitoringActualsRentsRetrieve.PATH = '/api/monitoring/actuals/rents/{id}/';
